export function parseProjectionData(data: Uint8Array): Record<string, unknown> {
  try {
    const parsed = JSON.parse(new TextDecoder().decode(data));
    if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    return Object.assign(Object.create(null), parsed) as Record<string, unknown>;
  } catch {
    return {};
  }
}
